
class Compare {
	constructor() {
		this.selectors = {
			document: document,
			removeProduct: '.js-remove-compare-product',
			addProduct: '.js-add-compare-product',
			compareRow: '.js-compare-row',
			compareSlider: '#compare-slider',
			compareGroups: '.compare-page .groups',
			comparePage: '#compare-page',
			compareFilter: '.js-compare-filter',
            tooltipBtn: '.trigger_btn',
		};

		this.init();
		this.events();
		this.slider();
		this.resizeRows();
		this.inProAjax = false;
	};

	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	// Get the Cookie
	getCookie(cname) {
		var name = cname + "=";
		var ca   = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var  c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if ( c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	removeCookie(cname, cvalue, exdays) {
		let value = cvalue;
		const d = new Date();
		const ids = this.getCookie('compare_products').split('+');
		var i = ids.indexOf(value);
		if (i != -1) {
			ids.splice(i, 1);
		}
		value = ids.join('+');
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		const expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + value + "; expires=" + expires + "; path=/";

	}

	resizeRows(){
		let rows = '';
		if(this.nodes.compareGroups.toArray().map){
			rows = this.nodes.compareGroups.toArray().map( ( elem ) => {
				return $(elem).find('.js-compare-row').toArray().map( ( elem ) => {
					return $(elem).height()
				} )
			} )
		}
		if ( rows.length > 1 ) {

			const maxHeights = rows[0].map( ( _, index ) => {
				return rows.map( ( cols, _ ) => {
					return cols[index]
				} )
			} ).map( ( cols ) => {
				return cols.sort( ( a, b ) => { return b - a } )[0]
			} )

			this.nodes.compareGroups.each( ( _, elem ) => {
				$( elem ).find( '.js-compare-row' ).each( ( index, elem ) => {
					$(elem).css('min-height', `${maxHeights[index]}px`)
					$(elem).css('max-height', `${maxHeights[index]}px`)
				} )
			} )
		}


	}

	slider() {
		/*----------  Compare products slider ----------*/
		this.nodes.compareSlider.slick({
				autoplay: false,
				dots: false,
				infinite: false,
				accessibility: false,
				prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
				nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>',
				slidesToShow: 3,
				slidesToScroll: 1,
				responsive: [{
					breakpoint: 1199,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: true
					}
				}, {
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
		})
	}

	events() {
		var self = this;

		self.nodes.tooltipBtn.on('click', e => {
            e.preventDefault();
			const $this = $(e.currentTarget);           
			const dataRow = $this.parent().parent();
			dataRow.css('overflow', 'initial');
			console.log(dataRow)
            const content = `<div class="trigger_content">
                                ${$this.data('title')}
                                <i class="trigger_content_close" aria-hidden="true"></i>
                            </div>`;           
             
            if ($this.siblings().length === 0) $(content).insertAfter($this);
            $('.trigger_content_close').on('click', e => {
				e.preventDefault();
                e.stopPropagation();
                const $this = $(e.currentTarget); 
                $this.parent().remove();                
				dataRow.css('overflow', 'hidden');
            });           
        }); 

		self.nodes.document.on('resize', () => {
			this.resizeRows()
		})

		self.nodes.compareFilter.on( 'change', () => {

			const checkedValue = $(`${self.selectors.compareFilter}:checked`).val()

			if ( checkedValue === 'diff' )
				self.nodes.comparePage.addClass( 'only-diff' )
			else
				self.nodes.comparePage.removeClass( 'only-diff' )

		} )

		self.nodes.compareRow.on('mouseover', function( e ){

			const $this = $(this)
			$(self.selectors.compareRow + '[data-row="' + $this.data('row') + '"]').addClass( 'active' )

		} )
		self.nodes.compareRow.on('mouseout', function( e ){

			const $this = $(this)
			$(self.selectors.compareRow + '[data-row=\'' + $this.data('row') + '\']').removeClass( 'active' )

		} )

		self.nodes.removeProduct.on('click', function(e){
			e.preventDefault();
			const $this = $(e.currentTarget);
			const id = $this.data('id').toString();
			const pathname = window.location.pathname; // Returns path only
			const urlPath = pathname.split('/');
			let url = urlPath[0]+'/'+urlPath[1]+'/'+urlPath[2];
			const ids = urlPath[3].split('+');
			var i = ids.indexOf(id);
			if(i != -1) {
				ids.splice(i, 1);
				url += '/'+ids.join('+');
				url += '/' + urlPath[4]
				location.assign(url);
			}
			self.removeCookie('compare_products', id, 30);
		});
		self.nodes.addProduct.on('click', function(e){
			e.preventDefault();
			const $this = $(e.currentTarget);
			const id = $this.data('id').toString();
			const pathname = window.location.pathname; // Returns path only
			const urlPath = pathname.split('/');
			let url = urlPath[0]+'/'+urlPath[1]+'/'+urlPath[2];
			const ids = urlPath[3].split('+');
			var i = ids.indexOf(id);
			if(i != -1) {
				ids.splice(i, 1);
				url += '/'+ids.join('+');
				location.assign(url);
			}
			self.setCookie('compare_products', id, 30, $this);
		});
	};

	//  Set the Cookie
	setCookie(cname, cvalue, exdays, current=null) {
		var self = this;
		let value = cvalue;
		const d = new Date();
		const ids = self.getCookie('compare_products') ? self.getCookie('compare_products').split('+') : [];
		var i = ids.indexOf(value);
		if (i != -1) {
			ids.splice(i, 1);
			current.removeClass('active-btn');
		} else {
			ids.unshift(value);
			current.addClass('active-btn');
		}

		while ( ids.length > 15 )
			ids.shift()

		value = ids.join('+');
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		const expires = "expires=" + d.toUTCString();
		const href = self.nodes.goToComparePage.data('href');
		self.nodes.goToComparePage.attr('href', href+value + '/');
		document.cookie = cname + "=" + value + "; expires=" + expires + "; path=/";

	}
}

new Compare();
